import React, { useEffect } from 'react';
import styled from 'styled-components';
import { IoArrowForwardOutline } from 'react-icons/io5';
import { Image, Select } from 'antd';
import { theme } from 'utils/style/theme';
import NoImage from 'components/etc/NoImage';

/**
 *
 * @returns {이미지 셀렉박스}
 */

//TODO!!!!!!!!!!!!!!!!
/*
react - jsx - dev - runtime.development.js: 117
Warning: React.jsx: type is invalid --expected a string(for built -in components) or a class/function (for composite components) but got: object.
 Check your code at PreviewImageSelect.js:48.
 에러남
*/
const { Option } = Select;
const PreviewImageSelect = ({
  value,
  optionList,
  imgUrl,
  onChange,
  name,
  title,
  height,
}) => {
  // if (optionList) {
  //   optionList?.unshift({ design_id: -1, value: -1, text: '---이미지를 선택해 주세요---' });
  // }

  useEffect(() => {
    for (let i = 0; i < optionList?.length; i++) {
      if (optionList[0].image_name !== '선택 없음') {
        optionList.unshift({
          image_name: '선택 없음',
          value: -1,
          text: '이미지 선택 없음',
        });
      }
    }
  }, []);
  // console.log(optionList, '<<<options');
  return (
    <Container height={height}>
      <OldBox height={height}>
        {imgUrl === '' || imgUrl === undefined ? (
          <NoImage color='#fff' />
        ) : (
          <Image src={imgUrl} alt='기존 이미지' />
        )}
      </OldBox>

      <div className='arrow_box'>
        <IoArrowForwardOutline size={15} />
      </div>

      <Select onChange={onChange} value={value} height={height}>
        {optionList?.map((v) => (
          <Option
            key={v.design_id}
            value={v.design_id}
            name={name}
            title={title}
          >
            {v.image_url ? (
              <Image src={v.image_url} width={`8rem`} />
            ) : (
              <p>{v.text}</p>
            )}
          </Option>
        ))}
      </Select>
    </Container>
  );
};

export default PreviewImageSelect;
const Container = styled.div`
  width: 100%;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;

  .arrow_box {
    svg {
      margin: 0 0.5rem;
      color: ${theme.colors.gray_3};
    }
  }

  .ant-select {
    width: 9rem;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 6rem;
    /* width: 9vw; */
    width: inherit;
    border: none;
    border-radius: 5px;
  }
  .ant-image {
    /* width: 80px; */
  }
  .ant-image-mask-info {
    position: absolute;
    top: 0;
  }

  .ant-select-item-option-content .ant-select-selection-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-select-selection-item {
    display: flex;
    align-items: center;
  }
`;

const OldBox = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  /* props로 height를 주지 않을 경우, 이미지에 맞춰서 높이 조정 */
  height: ${(props) => (props.height ? props.height : 'unset')};
  img {
    width: 6rem;
    /* height: inherit; */
    object-fit: cover;
    position: relative;
    transform: translate(0%, -0%);
  }
  .ant-image {
    /* position: absolute; */
    /* top: ${(props) => props.thumbnailPosition}; */
    top: ${(props) => props.thumbnailPosition};
  }
`;
